module.exports = __webpack_public_path__ + "img/top3.314bbfd8.png";